import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {
  FormArray,
  FormControl,
  NonNullableFormBuilder,
} from '@angular/forms';
import { LeadTask } from '../../../types/lead.type';
import { LeadsService } from '../../../modules/leads/services/leads.service';
import { InterfaceService } from '../../../services/interface.service';
import { ContextMenuService } from 'ngx-contextmenu';
import { BehaviorSubject, finalize, Subject, takeUntil } from 'rxjs';
import { SenderService } from '../../../services/sender.service';
import { Preset } from '../../../types/preset.type';
import { ToursService } from "../../../services/tours.service";
import { ShepherdService } from "angular-shepherd";

@Component({
  selector: 'app-leads-scan-tasks-edit',
  templateUrl: './leads-scan-tasks-edit.component.html',
  styleUrls: ['./leads-scan-tasks-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LeadsScanTasksEditComponent implements OnInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  constructor(
    private shepherdService: ShepherdService,
    public toursService: ToursService,
    public cd: ChangeDetectorRef,
    public senderService: SenderService,
    public contextMenuService: ContextMenuService,
    private interfaceService: InterfaceService,
    public leadsService: LeadsService,
    private fb: NonNullableFormBuilder
  ) {

  }

  @Input() copy = false;
  @Input() editLeadTask: LeadTask | false;
  @Output() onSave = new EventEmitter<void>();

  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  // Helper function to create a chat FormControl


  ngOnInit(): void {
    setTimeout(() => {
      requestAnimationFrame(() => {
        this.leadsService.taskForm.reset();
        // this.getControl('chats').clear();
        // this.getControl('text_variations').clear();
        if (this.editLeadTask) {
          this.cd.detach();
          this.leadsService.taskForm.get('name').setValue(this.editLeadTask.name);
          this.leadsService.taskForm.get('min_scope').setValue(
            parseFloat((this.editLeadTask.min_scope * 100).toFixed(2))
          );
          this.leadsService.taskForm.get('key_words').setValue(this.editLeadTask.key_words);
          this.leadsService.taskForm.get('negative_key_words').setValue(this.editLeadTask.negative_key_words);
          this.leadsService.taskForm.get('pause').setValue(this.editLeadTask.pause);
          this.leadsService.taskForm.get('all_chats').setValue(this.editLeadTask.all_chats);
          this.leadsService.taskForm.get('replay_type').setValue(this.editLeadTask.replay_type);
          this.leadsService.taskForm.get('no_create_lead').setValue(this.editLeadTask.no_create_lead);
          console.log('editLeadTask', this.editLeadTask);
          this.prepareDataList(this.editLeadTask, 'chats');
          this.prepareDataList(this.editLeadTask, 'text_variations');
          // Auto messages
          if (this.editLeadTask.auto_message) {
            this.leadsService.taskForm.get('auto_message').setValue(this.editLeadTask.auto_message.message);
            this.leadsService.taskForm.get('auto_message_active').setValue(this.editLeadTask.auto_message.active);
            this.senderService.message = this.editLeadTask.auto_message.message;
            this.leadsService.taskForm.get('auto_message_min_scope').setValue(
              parseFloat((this.editLeadTask.auto_message.min_scope * 100).toFixed(2))
            );
            this.leadsService.taskForm.get('auto_message_is_move_to').setValue(this.editLeadTask.auto_message.is_move_to);
          }
          this.cd.reattach();

        } else {
          this.addInput('chats');
          this.addInput('text_variations');
        }
      });
    }, 1000);


    this.leadsService.createTaskFromPreset$
      .pipe(takeUntil(this.destroy$))
      .subscribe((preset: Preset) => {
        const form = this.leadsService.taskForm;
        this.cd.detach();
        form.get('all_chats').setValue(false);
        form.get('name').setValue(preset.name);
        this.prepareDataList(preset, 'text_variations');
        this.prepareDataList(preset, 'chats');
        this.cd.reattach();
        // form.get('min_scope').setValue(preset.min_scope);
      });
  }

  prepareDataList(data: LeadTask | Preset, field: 'chats' | 'text_variations') {
    console.log('prepareDataList', data[field]);
    if (data[field]?.length > 0) {
      const values: string[] = typeof data[field] === 'string' ? JSON.parse(data[field]) : data[field];
      const controls: FormControl[] = values.map((v) => this.createControl(v));
      this.addInputs(field, controls);
      /*values.map((v) => {

        this.addInput(field, v);
      });*/
    } else {
      this.addInput(field);
    }
  }
  addInputs(field: 'chats' | 'text_variations', controls: FormControl[]) {
    // this.getControl(field).controls = controls;
    this.leadsService.taskForm.setControl(field, this.fb.array(controls));
  }
  submitForm(): void {
    if (this.leadsService.taskForm.valid) {
      this.isLoading$.next(true);
      console.log('submit', this.leadsService.taskForm.value);
      const accountId = this.senderService.account$.value.id;
      const values = this.leadsService.taskForm.value;
      const isEdit = (this.editLeadTask && !!this.editLeadTask?.id);
      const data: any = {
        name: values.name,
        min_scope: values.min_scope / 100,
        text_variations: JSON.stringify(values.text_variations),
        all_chats: values.all_chats,
        chats: JSON.stringify(values.chats),
        key_words: values.key_words,
        negative_key_words: values.negative_key_words,
        pause: values.pause,
        auto_message: this.senderService.message,
        auto_message_active: values.auto_message_active,
        auto_message_min_scope: values.auto_message_min_scope / 100,
        auto_message_is_move_to: values.auto_message_is_move_to,
        replay_type: values.replay_type,
        no_create_lead: values.no_create_lead
      };
      if (!this.editLeadTask || (this.editLeadTask && !this.editLeadTask?.id)) {
        data.account_id = accountId;
      }
      if (this.leadsService.taskForm.get('history_scanned').value) {
        data.history_scanned = false;
        data.history_scanned_chats = '';
        data.history_scanned_phrases = '';
      }
      if (this.editLeadTask && isEdit) {
        data.id = this.editLeadTask.id;
      }
      (isEdit ? this.leadsService.updateLeadTask(data) : this.leadsService.createLeadTask(data))
        .pipe(
          finalize(() => {
            this.isLoading$.next(false);
          })
        )
        .subscribe((res) => {
          console.log('', res);
          this.leadsService.reloadScanTasks$.next();
          this.onSave.next();
        }, error => {
          this.interfaceService.errorHandling(error, true);
        });
    } else {
      Object.values(this.leadsService.taskForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({onlySelf: true});
        }
      });
    }
  }


  addInput(field = 'chats', value = '') {
    this.getControl(field).push(this.createControl(value));
    this.cd.detectChanges();
  }

  removeInput(index: number, field = 'chats') {
    this.getControl(field).removeAt(index);
  }

  private createControl(value: string): FormControl {
    return this.fb.control(value);
  }

  setTypeChange(type: number): void {
    alert(type);
  }

  public getControl(field: string): FormArray {
    return this.leadsService.taskForm.get(field) as FormArray;
  }

  trackByFn(index, element: any) {
    return element;
  }

  onPaste(event: ClipboardEvent, fieldIndex: number, field = 'chats') {
    const pastedText = event.clipboardData.getData('text');
    if (pastedText.includes('\n')) {
      const arChats = pastedText.split('\n');
      const selfValue = arChats.shift().trim();
      setTimeout(() => {
        this.getControl(field).at(fieldIndex).setValue(selfValue);
      }, 100);
      arChats.forEach((v) => {
        this.addInput(field, v.trim());
      });
      console.log('Pasted Text:', pastedText);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  startLeadTaskTour() {
    localStorage.removeItem('lead_task_tour');
    this.toursService.startLeadTaskTour$.next(0);
    setTimeout(() => {
      this.shepherdService.next();
    }, 10);
  }
}
